enum InvitationVerificationCodeEnrollment {
    NONE = "NONE",
    DIRECT = "DIRECT"
}

export default InvitationVerificationCodeEnrollment;